import style from "../../assets/scss/sub/topBanner.module.scss";
import smallSettingIcon from "../../assets/images/mypage/small_setting_icon.svg";
import docIcon from "../../assets/images/mypage/doc_icon.svg";
import couponIcon from "../../assets/images/mypage/coupon_icon.svg";
import allCouponIcon from "../../assets/images/mypage/all_coupon_icon.svg";
import kIcon from "../../assets/images/mypage/small_k_icon.svg";
import dIcon from "../../assets/images/mypage/small_d_icon.svg";
import settingDarkIcon from "../../assets/images/mypage/setting_dark_icon.svg";
import { getAllCouponCountAsync } from "../../store/coupon/couponSlice";
import { useAppDispatch } from "../../hooks/hooks";
import { useCallback, useEffect, useState } from "react";
import { getProfilesAsync } from "../../store/profile/profileSlice";
import { UserProfile as ImportedUserProfile } from "../../types/user";
import { useUserInfoGetter } from "../common/hooks/useUserInfoGetter";
import { useNavigate } from "react-router-dom";

interface CouponApiResponse {
  totalPages: number;
  totalElements: number;
  number: number;
  size: number;
  numberOfElements: number;
  content: any[]; // 필요한 경우 정확한 타입으로 변경
  orders: {
    direction: string;
    property: string;
    ignoreCase: boolean;
    nullHandling: string;
    ascending: boolean;
    descending: boolean;
  }[];
  first: boolean;
  last: boolean;
  empty: boolean;
  pageable: {
    sort: {
      sorted: boolean;
      unsorted: boolean;
      empty: boolean;
    };
    pageNumber: number;
    pageSize: number;
    offset: number;
    paged: boolean;
    unpaged: boolean;
  };
}

interface TopBannerProps {
  totalVoucherData: {
    organDcasVoucherCnt: number;
    organKpassVoucherCnt: number;
  };
}

export function TopBanner({ totalVoucherData }: TopBannerProps) {
  const dispatch = useAppDispatch();
  const [totalCouponCount, setTotalCouponCount] = useState(0);
  const [totalTestCount, setTotalTestCount] = useState(0);

  const { user } = useUserInfoGetter();
  const navigate = useNavigate();

  // 보유쿠폰수
  const getAllCouponCount = useCallback(async () => {
    try {
      const response = (await dispatch(getAllCouponCountAsync()).unwrap()) as CouponApiResponse;
      setTotalCouponCount(response.numberOfElements);
    } catch (error) {
      console.log(error);
    }
  }, [dispatch]);

  // 누적검사횟수
  const getProfileList = useCallback(async () => {
    try {
      const response = (await dispatch(getProfilesAsync()).unwrap()) as ImportedUserProfile[];
      // 모든 프로필의 testCnt를 더하는 코드
      const totalTestCnt = response.reduce((total, profile) => total + profile.testCnt, 0);
      setTotalTestCount(totalTestCnt);
    } catch (error) {
      console.log(error);
    }
  }, [dispatch]);

  useEffect(() => {
    getAllCouponCount().then();
    getProfileList().then();
  }, [getAllCouponCount, getProfileList]);

  return (
    <div className={style.myPageBanner}>
      <div className={style.topTextContainer}>
        <span className={style.greetingText}>
          <span className={style.strong}>{user?.name}</span> 님 안녕하세요 :)
        </span>
        <button className={style.memberInfoBtn} onClick={() => navigate(`/mypage/user`)}>
          <img src={smallSettingIcon} />
          회원정보
        </button>
        <img className={style.mobileMemberInfoIcon} src={settingDarkIcon} alt="settings" onClick={()=>navigate(`/mypage/user`)}/>
      </div>
      <div className={style.bottomTextContainer}>
        <div className={style.countContainer}>
          <div className={style.docIcon}>
            <img src={docIcon} className={style.iconImg} />
          </div>
          <div className={style.textArea}>
            <div className={style.textTitle1}>누적 검사 횟수</div>
            <div className={style.numberText}>{totalTestCount}회</div>
          </div>
        </div>
        <div className={style.verticalLine}></div>
        <div className={style.countContainer}>
          <div className={style.docIcon}>
            <img src={couponIcon} className={style.iconImg} />
          </div>
          <div className={style.textArea}>
            <div className={style.textTitle2}>보유 쿠폰</div>
            <div className={style.numberText}>{totalCouponCount}장</div>
          </div>
        </div>
        <div className={style.verticalLine}></div>
        <div className={style.countContainer}>
          <div className={style.docIcon}>
            <img src={allCouponIcon} className={style.iconImg} />
          </div>
          <div className={style.textArea}>
            <div className={style.textTitle3}>보유 이용권(소속+검사)</div>
            <div className={`${style.numberText} ${style.mobileNumberText}`}>
              <div className={style.couponContainer}>
                <img src={kIcon} className={style.kIcon} />
                <span className={style.kPassCount}>
                  {totalVoucherData?.organKpassVoucherCnt ? totalVoucherData?.organKpassVoucherCnt : 0}매
                </span>
              </div>
              <div className={style.couponContainer}>
                <img src={dIcon} className={style.dIcon} />
                <span className={style.dCasCount}>
                  {totalVoucherData?.organDcasVoucherCnt ? totalVoucherData?.organDcasVoucherCnt : 0}매
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
